import { ESearchResultsActionType } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const openSearchResultsSidebar = actionGenerator<ESearchResultsActionType.SidebarOpened>(
  ESearchResultsActionType.SidebarOpened,
);
